<template>
    <div class="main d-flex justify-content-center m-bottom-full m-bottom-lg-default">
        <div class="content" :class="{loader : loader}">
<!--            <div class="d-flex d-lg-none justify-content-center align-items-center">-->
<!--                <a href="javascript:void(0);" class="btn btn-primary mt-4" @click="$refs.sidebar.open()">-->
<!--                    <span class="bi bi-list-check me-2"></span>Change preferences-->
<!--                </a>-->
<!--            </div>-->
            <div v-if="filteredTypes.length > 0" class="row product-grid-container">
                <div v-for="type in filteredTypes" :key="type.id"
                     class="col-md-6 col-lg-6 col-xl-4 col-4xl-4 col-5xl-4 p-0">
                    <TypeDetail
                        :type="type"
                        :time-option="timeOptions"/>
                </div>
            </div>
            <div v-else class="container text-center">
                <img class="illustration" src="/assets/images/illustrations/broken-bike.png" alt="error-404">
                <ChalkDecoration class="m-auto">
                    <h2 class="text-uppercase">Bikes not found</h2>
                    <h5>Please change your filter's preferences.</h5>
                </ChalkDecoration>
            </div>
        </div>
    </div>
</template>

<script>
import SearchBar from "../components/elements/SearchBar";
import SettingsMixin from "../../mixins/SettingsMixin";
import {mapActions, mapGetters} from "vuex";
import ChalkDecoration from "../components/elements/ChalkDecoration";
import RentalsFilter from "../components/blocks/RentalsFilter";
import TypeDetail from "../components/cards/TypeDetail.vue";

export default {
    name: "Rentals",
    mixins: [SettingsMixin],
    components: {TypeDetail, RentalsFilter, ChalkDecoration, SearchBar},
    data: function () {
        return {
            loader: false
        }
    },
    computed: {
        ...mapGetters('app', ['timeOptions', 'types', 'settings']),
        ...mapGetters('filter', ['duration', 'keyword', 'rentLocation', 'journeyDate']),
        filteredTypes: function () {
            let types = this.types;

            if (this.settings.location) {
                types = types.filter(i => i.bike_location.filter(b => this.settings.location.id === b.location_id).length);
            }
            return types.sort((a, b) => {
                return a.sorting_number > b.sorting_number ? 1 : -1
            });
        }
    },
    methods: {
        ...mapActions('app', ['fetchTimeOptions', 'fetchTypes']),
        changeLoaderState(value) {
            this.loader = value
        }

    },
    beforeMount() {
        this.fetchTimeOptions();
        this.fetchTypes();
    },
    mounted() {
        // this.settings.altLocations
    }
}
</script>

<style scoped>

</style>
